import request from "@/utils/request";

// 珠宝商品列表
export function lists(data) {
    return request({
        url: `business/jewelry-goods/lists`,
        method: "GET",
        params: data
    });
}

// 珠宝商品添加
export function addJewelry(data) {
  return request({
      url: `business/jewelry-goods/post`,
      method: "POST",
      data: data
  });
}

// 珠宝商品编辑
export function editJewelry(data) {
  return request({
      url: `business/jewelry-goods/put/${data.id}`,
      method: "PUT",
      data: data
  });
}

// 珠宝商品删除
export function delJewelry(id) {
  return request({
      url: `business/jewelry-goods/del/${id}`,
      method: "DELETE",
  });
}
// 珠宝商品 批量删除
export function jewelryDel(data) {
  return request({
      url: `business/jewelry-goods/batch-del`,
      method: "post",
      data
  });
}

// 珠宝商品 详情
export function jewelryDetail(id) {
  return request({
      url: `business/jewelry-goods/get/${id}`,
      method: "GET",
  });
}

// 珠宝商品 批量上下架
export function batchStatus(data) {
  return request({
      url: `business/jewelry-goods/batch-status`,
      method: "POST",
      data:data
  });
}

// 珠宝商品 批量热门、取消热门
export function batchTop(data) {
  return request({
      url: `business/jewelry-goods/batch-hot`,
      method: "POST",
      data:data
  });
}
// 珠宝商品 导出
export function jewelryExport(data) {
  return request({
      url: `business/jewelry-goods/export`,
      method: "POST",
      data:data
  });
}

// 获取料价材料
export function getMaterial(data) {
  return request({
      url: `business/jewelry-goods/material-quality-price`,
      method: "GET",
      params: data
  });
}